module.exports = __webpack_public_path__ + "img/monitor.97018988.png";